<template>
  <el-button @click="click">
    <slot></slot>
  </el-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * JR用ボタン
 */
export default defineComponent({
  name: 'JrButtonForJr',
  emits: ['click'],
  setup(props, context) {
    return {
      click: () => {
        context.emit('click')
      },
    }
  },
})
</script>

<style lang="scss" scoped>
button {
  color: #fff;
  background-color: #c00000;
  border-color: #c00000;
}
button:hover {
  color: #fff;
  background-color: #c00000;
  border-color: #c00000;
  opacity: 0.7;
}
</style>
